export default "/images/location.png?5f38c14d6eacb5a88a18ef371ecb8816";